import DataBlockLabel from "../account/DataBlockLabel";
import DataRow from "../account/DataRow";
import Button from "../general/Button";
import InvoiceServices from "../../services/Invoice.services";
import AddressFormatServices from "../../services/AddressFormat.services";
import {useState, useEffect} from "react";
import BasicFormPopup from "../content/BasicFormPopup";
import CreateCustomerForm from "../form/CreateCustomerForm";
import ClientServices from "../../services/Client.services";
import InfiniteScroll from "react-infinite-scroll-component";
import SingleClient from "../clients/SingleClient";
import EditCustomerForm from "../form/EditCustomerForm";


export default function ClientData({
                                       invoiceData,
                                       jwtToken,
                                       style
                                   }) {

    const [showCustomerSelectPopup, setShowCustomerSelectPopup] = useState(false);
    const [showCreateCustomerPopup, setCreateCustomerPopup] = useState(false);
    const [showEditCustomerPopup, setEditCustomerPopup] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [clients, setClients] = useState([]);
    const [page, setPage] = useState(0);
    const [moreClients, setMoreClients] = useState(true);

    const fetchClients = async () => {
        setPage(page + 1);
        let newClients = await ClientServices.getClients(jwtToken, page, 20);

        newClients?.clients?.length > 0
            ? setClients(clients.concat(newClients.clients))
            : setMoreClients(false);
    };

    useEffect(() => {
        if (isPopupOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isPopupOpen]);


    const openCreatePopup = () => {
        setCreateCustomerPopup(true);
        setIsPopupOpen(true);
    }
    const closeCreatePopup = () => {
        setCreateCustomerPopup(false);
        setIsPopupOpen(false);
    };

    const openShowPopup = () => {
        fetchClients();
        setShowCustomerSelectPopup(true);
        setIsPopupOpen(true);
    }

    const closeShowPopup = () => {
        setShowCustomerSelectPopup(false);
        setIsPopupOpen(false);
    };

    const openEditPopup = () => {
        setEditCustomerPopup(true);
        setIsPopupOpen(true);
    }

    const closeEditPopup = () => {
        setEditCustomerPopup(false);
        setIsPopupOpen(false);
    }

    const disconnectClientFromInvoice = () => {
        InvoiceServices.detachClient(jwtToken, invoiceData);
    };

    const createSelfAsClient = async () => {
        await InvoiceServices.selfclient(jwtToken, invoiceData.uid);
    };

    const disconnectedHtml = () => {
        return (<>
            <Button
                text="Bestaande klant"
                leftIcon="/assets/icon/customer-green.svg"
                rightIcon="/assets/icon/chevron-right-white.svg"
                style="secondary"
                handleClick={openShowPopup}
                className="mt-2"
            />
            <Button
                text="Nieuwe klant"
                leftIcon="/assets/icon/customer-new.svg"
                rightIcon="/assets/icon/add.svg"
                style="secondary"
                className="mt-2"
                handleClick={openCreatePopup}
            />
            <div className={"mt-2"}>
                <div
                    onClick={createSelfAsClient}
                    className={
                        "px-8 group cursor-pointer w-full h-[40px] flex items-center rounded-tl-[10px] rounded-br-[10px] text-sm lg:text-base font-bold border-2 transition duration-200 ease-in-out bg-transparent text-olaf-green-500 border-olaf-green-500 hover:bg-olaf-green-500 hover:text-white"
                    }
                >
                    <img
                        src={"/assets/icon/tree.svg"}
                        alt="Left icon"
                        className="mr-4 h-2/5 w-auto transition duration-200 ease-in-out group-hover:brightness-0	group-hover:invert"
                    />
                    Eigen gebruik
                    <img
                        src={"/assets/icon/chevron-right.svg"}
                        alt="Right icon"
                        className="ml-auto transition duration-200 ease-in-out group-hover:brightness-0	group-hover:invert"
                    />
                </div>
            </div>
        </>)
    }

    const connectedHtml = () => {
        return (<div className="mt-2 bg-white px-4 py-5 rounded-tl-lg rounded-br-lg space-y-6">
            {invoiceData?.client?.company_name && (
                <>
                    <DataRow
                        label="Bedrijfsnaam"
                        data={invoiceData?.client?.company_name}
                    />
                    <DataRow
                        label="Contact"
                        data={`${invoiceData?.client?.first_name} ${invoiceData?.client?.last_name}`}
                    />
                </>
            )}

            {!invoiceData?.client?.company_name && (
                <DataRow
                    label="Klantnaam"
                    data={`${invoiceData?.client?.first_name} ${invoiceData?.client?.last_name}`}
                />
            )}

            <DataRow
                label="Adres"
                data={`${AddressFormatServices.format(
                    invoiceData?.client?.address?.line1,
                    invoiceData?.client?.address?.houseNumber,
                    invoiceData?.client?.address?.line2
                )}, ${invoiceData?.client?.address?.postal_code} ${
                    invoiceData?.client?.address?.city
                }`}
            />
            <span
                className={
                    "transition duration-300 ease-in-out cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-white border-[#58694C] text-[#58694C] hover:bg-olaf-green-500 hover:text-white"
                }
                onClick={(e) => openEditPopup(e)}
            >
                Klant wijzigen
            </span>

            <span
                className={
                    "transition duration-300 ease-in-out cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-white border-[#8B0000] text-[#8B0000] hover:bg-[#8B0000] hover:text-white"
                }
                onClick={(e) => disconnectClientFromInvoice(e)}
            >
                Andere klant kiezen
            </span>
        </div>)
    }

    return (
        <section className={`${style}`}>
            <div className="">
                <DataBlockLabel text={`Ik maak deze offerte voor`}/>
                {invoiceData?.client
                    ? connectedHtml()
                    : disconnectedHtml()
                }
            </div>

            {showCreateCustomerPopup &&
                <BasicFormPopup title={'Klant aanmaken'} closePopupFn={closeCreatePopup}>
                    <CreateCustomerForm closePopupFn={closeCreatePopup} jwtToken={jwtToken} invoice={invoiceData?.uid}/>
                </BasicFormPopup>
            }

            {showCustomerSelectPopup &&
                <BasicFormPopup title={'Bestaande klant kiezen'} closePopupFn={closeShowPopup}>
                    <div>
                        <InfiniteScroll
                            dataLength={clients?.length}
                            next={fetchClients}
                            hasMore={moreClients}
                            className="!overflow-hidden"
                            loader={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="animate-spin w-12 h-12 lg:w-16 lg:h-16 mx-auto mt-8 fill-olaf-orange-500"
                                >
                                    <path
                                        d="M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z"/>
                                </svg>
                            }
                        >
                            {clients?.map((
                                {id, uid, first_name, last_name, name, company_name}, i
                            ) => {
                                return (
                                    <div key={i}>
                                        <SingleClient i={i} id={id} uid={uid} first_name={first_name}
                                                      last_name={last_name} name={name} company_name={company_name}
                                                      offerte={invoiceData?.uid} jwtToken={jwtToken}
                                                      closeShowPopup={closeShowPopup}/>
                                    </div>
                                );
                            })}


                        </InfiniteScroll>
                    </div>
                </BasicFormPopup>
            }

            {showEditCustomerPopup &&
                <BasicFormPopup title={'Klant aanpassen'} closePopupFn={closeEditPopup}>
                    <EditCustomerForm closePopupFn={closeEditPopup} customer={invoiceData?.client} jwtToken={jwtToken}/>
                </BasicFormPopup>
            }

        </section>
    );
}
